import { SVGIconComponent } from './types';

export const BoolNo: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="45px"
    height="45px"
    viewBox="0 0 45 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M22.461,44.922 C10.074,44.922 0,34.848 0,22.461 C0,10.074 10.074,0 22.461,0 C34.848,0 44.922,10.074 44.922,22.461 C44.922,34.848 34.848,44.922 22.461,44.922 Z M22.461,3.906 C12.231,3.906 3.906,12.2302 3.906,22.461 C3.906,32.691 12.2302,41.016 22.461,41.016 C32.691,41.016 41.016,32.6918 41.016,22.461 C41.016,12.231 32.6918,3.906 22.461,3.906 L22.461,3.906 Z"
        id="Shape"
        fill="#FFFFFF"
        fillRule="nonzero"
      ></path>
      <path
        d="M13.672,33.203 C13.172,33.203 12.672,33.01159 12.2892,32.63269 C11.52748,31.87097 11.52748,30.63269 12.2892,29.87099 L29.8672,12.29299 C30.62892,11.53127 31.8672,11.53127 32.6289,12.29299 C33.3906,13.05471 33.39062,14.29299 32.6289,15.05469 L15.0509,32.63269 C14.67199,33.0116 14.17199,33.203 13.672,33.203 L13.672,33.203 Z"
        id="Path"
        fill="#FFFFFF"
        fillRule="nonzero"
      ></path>
      <path
        d="M31.25,33.203 C30.75,33.203 30.25,33.01159 29.8672,32.63269 L12.2892,15.05469 C11.52748,14.29297 11.52748,13.05469 12.2892,12.29299 C13.05092,11.53127 14.2892,11.53127 15.0509,12.29299 L32.6289,29.87099 C33.39062,30.63271 33.39062,31.87099 32.6289,32.63269 C32.24999,33.0116 31.74999,33.203 31.25,33.203 Z"
        id="Path"
        fill="#FFFFFF"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
